module.exports = __webpack_public_path__ + "img/icon-locate-r.daa59e77.svg";